import { memo } from 'react'
import { usePress } from '@react-aria/interactions'
import cn from 'classnames'

import { SWITCH_THUMB_CHECKED_COLOR } from './config'
import type { SwitchProps } from './types'

import styles from './Switch.module.scss'

/** Тумблер 48×28, спека 01. */
export const Switch = memo(function Switch(props: SwitchProps) {
  const { isChecked, onChange, isDisabled = false, ariaLabel } = props

  const { pressProps, isPressed } = usePress({
    onPress: () => onChange(!isChecked),
    isDisabled,
  })

  return (
    <button
      className={cn(styles.root, isChecked && styles.isChecked)}
      type='button'
      role='switch'
      aria-checked={isChecked}
      aria-label={ariaLabel}
      aria-disabled={isDisabled || undefined}
      data-pressed={isPressed}
      {...pressProps}
    >
      {/* #fff6e8 — буквальное значение спеки, своего токена нет (см. config.ts). */}
      <span
        className={styles.thumb}
        style={isChecked ? { background: SWITCH_THUMB_CHECKED_COLOR } : undefined}
      />
    </button>
  )
})
